import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record13Api = {
    //查詢用戶公司記錄
    "getUserRecordList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record13/getRecord13List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                recordno: 1,
                companycode: null,
                login: null,
                addinfo1: null,
                addinfo2: null
            }
        }
    },
    //查詢名片公司記錄
    "getCardRecordList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record13/getRecord13List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                recordno: 2,
                companycode: null,
                login: null,
                addinfo1: null,
                addinfo2: null
            }
        }
    },
    //通过原公司代码查询用戶公司記錄
    "getUserRecordListByCompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record13/getRecord13List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                recordno: 1,
                addinfo3: null
            }
        }
    },


}

export default record13Api